import { Feature } from "@evergis/sgis";
import { Crs } from "@evergis/sgis/es/Crs";
import { Polygon } from "@evergis/sgis/es/features/Polygon";
import { ShadowedPolySymbol } from "../../../../../../react-sgis/symbols/editorSymbols/ShadowedPolySymbol";

export const createPointsPolygonFeature = (rings, crs: Crs, symbol: ShadowedPolySymbol): Feature | Feature[] => {
  const feature = new Polygon(rings, { crs });

  feature.symbol = symbol.clone();

  return feature;
};
